module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-ticad9-bg-1-sp-5cb2de767fe7d7ebf07a5622ec886f31.png";